import PropTypes from "prop-types";

const propTypes = {
  children: PropTypes.node.required,
};

export const Wrapper = ({ children, ...props }) => {
  return <div {...props}>{children}</div>;
};

Wrapper.propTypes = propTypes;

export default Wrapper;
